import styled from 'styled-components';

import Text from 'components/Text';

export const DevolutionTicketGridRow = styled.div`
    display: flex;
    align-items: center;
    height: 2.5rem;
    max-height: 2.5rem;
    padding: 1.5625rem 0.9375rem;
    gap: 1.875rem;
`;

export const LabelText = styled(Text)`
    padding-right: 5px;
    font-size: 0.875rem !important;
`;

export const ContentText = styled(Text)`
    font-weight: bold;
    font-size: 0.875rem !important;
`;